module.exports = __webpack_public_path__ + "static/img/loading-icon.c67c881.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/loading-icon.png
// module id = 649
// module chunks = 2